var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-page',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('render-content',{attrs:{"id":"about"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }